module.exports = __webpack_public_path__ + "img/AI_16.4232acbe.png";